import React, { CSSProperties } from "react";
import { Controller, Scene } from "react-scrollmagic";

import "./SampleLinkButton.scss";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { OrientationContext } from "../../provider/OrientationProvider";
import { MAX_WIDTH, MAX_WIDTH_STR } from "../../model/Const";
import { IUADevice, userAgentInfo } from "../../model/UserAgentInfo";

const LinkButtonAreaParentDiv = styled.div`
	height: 10vh;
	position: relative;
	background-color: white;
`;

const LinkButtonAreaDiv = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`;

const LinkButtonDiv = styled.div`
	width: 100%;
	height: 300px;
	position: relative;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`;

const ButtonLabelDiv = styled.div`
	font-size: 5vmin;
	border-radius: 1vmin;
	background-color: mediumaquamarine;
	color: white;
	font-weight: bold;
	padding: 0.5vmin 2vmin 1vmin 2vmin;
	font-family: nicomoji;
	user-select: none;
`;

const createAnchor = (
	props: {
		toURL: string,
		text: string
	}
) => {
	const anchorStyle: CSSProperties = {
		right: "5vmin",
		position: "absolute",
		textDecoration: "none"
	};
	// if ( props.useLink ) {
	// 	return <Link to={props.toURL}
	// 				 style={anchorStyle}
	// 	>
	// 		<ButtonLabelDiv>
	// 			{props.text}
	// 		</ButtonLabelDiv>
	// 	</Link>
	// }

	return <a href={props.toURL} target="_blank" rel="noopener noreferrer" style={anchorStyle}>
		<div
			style={{
				fontSize: "5vmin",
				borderRadius: "1vmin",
				backgroundColor: "mediumaquamarine",
				color: "white",
				fontWeight: "bold",
				padding: "0.5vmin 2vmin 1vmin 2vmin",
				fontFamily: "nicomoji",
				userSelect: "none"
			}}
		>
			{props.text}
		</div>
	</a>;
};

export const SampleLinkButton = React.memo( ( props: {
	toURL: string,
	text: string
} ) => {
	// useContext
	const context = React.useContext( OrientationContext );

	// 最大幅を設定するスタイル（PCの場合のみ設定）
	const maxWidthStyle = React.useMemo( () => {
		// 幅が最大幅より大きく、PCだったら最大幅を指定
		if ( window.innerWidth > MAX_WIDTH && userAgentInfo.device === IUADevice.pc ) {
			return {
				maxWidth: MAX_WIDTH_STR,
				margin: "auto"
			}
		}

		return undefined;
	}, [context.resize] );

	return <LinkButtonAreaParentDiv>
		<LinkButtonAreaDiv style={{
			...maxWidthStyle,
		}}>
			<Controller>
				<Scene
					duration="50%"
					triggerHook={0.8}
					classToggle={"catch"}
				>
					<LinkButtonDiv className={"sampleBt"}>
						{createAnchor( props )}
					</LinkButtonDiv>
				</Scene>
			</Controller>
		</LinkButtonAreaDiv>
	</LinkButtonAreaParentDiv>;

	// return <LinkButtonAreaDiv
	// 	style={{
	// 		backgroundColor: "white" // backgroundColor
	// 	}}
	// >
	// 	<Controller>
	// 		<Scene
	// 			duration="20%"
	// 			pin={true}
	// 			indicators={true}
	// 		>
	// 			<LinkButtonDiv>
	// 				{createAnchor( props )}
	// 			</LinkButtonDiv>
	// 		</Scene>
	// 	</Controller>
	// </LinkButtonAreaDiv>;
} );

export default SampleLinkButton;